import { DatePipe } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ErrorHandler, ModuleWithProviders, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { LocalStorage } from "./classes/localstorage";
import { SessionStorage } from "./classes/sessionstorage";

import { getStorageFactory } from "./factories/storagefactory";

import { SpinnerInterceptor } from "./services/interceptors/spinner.interceptor";
import { WithCredentialsInterceptor } from "./services/interceptors/withcredentials.interceptor";
import { PCPErrorHandler } from "./services/pcperror.handler";

import { API_ROOT, APPINSIGHTS_KEY, PCP_URL, SECURE_LOCAL_STORAGE, SECURE_SESSION_STORAGE, STORAGE, TARGET } from "./types/constants/appconstants";
import { AuthConfig, AUTH_CONFIG, OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';

export function oAuthModuleConfigFactory(apiUrl: string) {
    return {
        resourceServer:
        {
            allowedUrls: [apiUrl], //URL of your API
            sendAccessToken: true
        }
    };
}

export function oAuthStorageFactory(): OAuthStorage {
    return localStorage;
}

@NgModule({
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        DatePipe,
        {
            "provide": ErrorHandler,
            "useClass": PCPErrorHandler
        },
        {
            "provide": HTTP_INTERCEPTORS,
            "useClass": WithCredentialsInterceptor,
            "multi": true
        },
        {
            "provide": HTTP_INTERCEPTORS,
            "useClass": SpinnerInterceptor,
            "multi": true
        },
        {
            provide: SECURE_LOCAL_STORAGE,
            useFactory: getStorageFactory(LocalStorage)
        },
        {
            provide: SECURE_SESSION_STORAGE,
            useFactory: getStorageFactory(SessionStorage)
        },
        {
            provide: OAuthStorage,
            useFactory: oAuthStorageFactory
        }
    ], imports: [RouterModule, OAuthModule.forRoot()]})

export class PCPCommonModule {
    static forRoot(apiroot: string, appinsightskey: string, authconfig: AuthConfig, pcpurl: string, storage: string, target: string): ModuleWithProviders<PCPCommonModule> {
        return {
            ngModule: PCPCommonModule,
            providers: [{
                provide: API_ROOT,
                useValue: apiroot
            },
            {
                provide: AUTH_CONFIG,
                useValue: authconfig
            },
            {
                provide: APPINSIGHTS_KEY,
                useValue: appinsightskey
            },
            {
                provide: STORAGE,
                useValue: storage
            },
            {
                provide: PCP_URL,
                useValue: pcpurl
            },
            {
                provide: TARGET,
                useValue: target
            }]
        };
    }
}
